import { useSuspenseQuery } from '@apollo/client';
import ApolloErrorBoundary from '@components/ApolloErrorBoundary';
import { GET_LAST_CONNECTION_STATE } from '@features/gateOperationModal/graphql/queries/getLastConnectionState';
import { type FC, Suspense, useEffect } from 'react';

interface RenderProps {
  lastConnection: [number, number] | null;
}

interface Props {
  movementId: number;
  render: FC<RenderProps>;
  fallback: FC;
}

const POLLING_INTERVAL = 30_000; // 30 seconds;

export const ConnectionStateRenderer: FC<Props> = (props) => {
  const Fallback = props.fallback;

  return (
    <ApolloErrorBoundary variant="section-alert">
      <Suspense fallback={<Fallback />}>
        <SuspenseComponent {...props} />
      </Suspense>
    </ApolloErrorBoundary>
  );
};

const SuspenseComponent: FC<Props> = ({ movementId, render: Render }) => {
  const { data, refetch } = useSuspenseQuery(GET_LAST_CONNECTION_STATE, {
    variables: {
      movementId,
    },
  });

  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, POLLING_INTERVAL);

    return () => {
      clearInterval(interval);
    };
  }, [refetch]);

  const lastConnection = data.gateMovement.gate.mainDevice.metrics.connectionState.lastData ?? null;
  return <Render lastConnection={lastConnection} />;
};
